import React from 'react'
import { Typography, Button, Box } from '@mui/material'
import styled from '@emotion/styled'
import { colors } from '../../../tokens/colors'
import { FullWidth } from '../Misc/FullWidth'

type Props = {
  asset: {
    id: number
    assetDetails: {
      note: string
      url: string
      buttonText: string
    }
  }
  colorTheme: string
  backgroundColor?: string
  onClick?: () => void
}

export const CTABlockPublic = ({
  asset,
  colorTheme,
  backgroundColor,
  onClick,
}: Props): JSX.Element => {
  const themeColor = colorTheme || undefined
  if (
    asset.assetDetails.url === null ||
    asset.assetDetails.buttonText === null
  ) {
    return <span />
  }

  return (
    <FullWidth backgroundColor={backgroundColor}>
      <Container>
        <PreviewNote>{asset.assetDetails.note}</PreviewNote>
        <a
          href={asset.assetDetails.url}
          target='_blank'
          rel='noreferrer'
          id={`public-cta-button-${asset.id}`}
        >
          <PreviewButton
            variant='contained'
            style={{ backgroundColor: themeColor }}
            onClick={onClick}
          >
            {asset.assetDetails.buttonText}
          </PreviewButton>
        </a>
      </Container>
    </FullWidth>
  )
}

const Container = styled(Box)`
  max-width: 672px;
  margin: 0 auto;
  text-align: center;
  & a {
    display: inline-block;
    text-decoration: none;
    max-width: 100%;
  }
  & a:active {
    text-decoration: none;
  }
  & a:visited {
    text-decoration: none;
  }
`

const PreviewNote = styled(Typography)`
  font-family: 'Source Sans Pro';
  font-weight: 600;
  font-size: 22px;
  text-align: center;
  margin-bottom: 18px;
`

const PreviewButton = styled(Button)`
  max-width: 100%;
  width: 301px;
  font-family: 'Source Sans Pro';
  font-weight: bold;
  font-size: 18px;
  color: white;
  display: block;
  margin: 0 auto;
  background-color: #47855c;
  &:hover {
    background-color: ${colors.customization.shadeGreen};
  }
`
